import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { renderFieldHora } from '../../util/inputs';
import { showAlertMsg, showSuccessMsg } from '../../util/messagesUtil';
import cadastrarControleEmissaoBpe from '../../actions/bpe/cadastrarControleEmissaoBpe';
import { gerarHashForString } from '../../util/stringUtil';
import $ from 'jquery';

export class ModalCadastrarControleEmissaoBPe extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
  }

  limparFormulario() {
    this.props.reset('formularioCadastroControle');
    this.props.limparControleEmissaoBpe();
  }

  limparCampos() {

    this.props.changeFieldValue('formularioCadastroControle',
      'id', '');
    this.props.changeFieldValue('formularioCadastroControle',
      'dataHora', '');
    this.props.changeFieldValue('formularioCadastroControle',
      'horaInicio', '');
    this.props.changeFieldValue('formularioCadastroControle',
      'horaFim', '');
    this.props.changeFieldValue('formularioCadastroControle',
      'configBpe', '');
  }

  limparCamposControle() {
    this.props.changeFieldValue('formularioCadastroControle', 'horaInicio', '');
    this.props.changeFieldValue('formularioCadastroControle', 'horaFim', '');
  }

  submit() {
    this.props.cadastrarControleEmissaoBpe(this.montarParametroControle()).then(() => {
      showSuccessMsg('Controle Emissao cadastrada com sucesso');
      this.props.buscarConfiguracoesBPe();
      this.limparCampos();
      this.props.buscarConfiguracoesBPe()
      this.fecharModal();
    })
  }

  fecharModal() {
    $('#modalCadastrarControleEmissaoBPe')
        .modal('hide');
    $('#modalCadastrarControleEmissaoBPe')
        .hide();
    $('.modal-backdrop')
        .hide();
    this.limparFormulario();
}

  montarParametroControle() {
    return {
      idEmpresa: this.props.codigoEmpresaSelecionada,
      controlesEmissaoBpe: this.props.controleEmissaoBpe
    };
  }

  adicionarControle(event) {
    event.preventDefault();
    const { horaInicio, horaFim, controleEmissaoBpe } = this.props;
    if (!horaInicio || !horaFim || horaInicio >= horaFim) {
      showAlertMsg('Selecione horários válidos.');
      return;
    }
  
    const temIntersecao = controleEmissaoBpe.some((controle) => {
      const inicioExistente = new Date(`2000-01-01T${controle.horaInicio}`).getTime();
      const fimExistente = new Date(`2000-01-01T${controle.horaFim}`).getTime();
      const novoInicio = new Date(`2000-01-01T${horaInicio}`).getTime();
      const novoFim = new Date(`2000-01-01T${horaFim}`).getTime();
  
      return (
        (novoInicio >= inicioExistente && novoInicio < fimExistente) ||
        (novoFim > inicioExistente && novoFim <= fimExistente) ||
        (novoInicio <= inicioExistente && novoFim >= fimExistente) ||
        (novoInicio >= inicioExistente && novoFim <= fimExistente)
      );
    });
  
    if (temIntersecao) {
      showAlertMsg('Os horários têm interseção. Selecione horários que não se sobreponham.');
      return;
    } else {
      const controle = {
        id: null,
        hash: gerarHashForString(`${horaInicio}-${horaFim}`),
        horaInicio,
        horaFim,
        configBpe: this.props.configuracaoBPeSelecionada.id,
      };
      this.props.adicionarControle(event, controle);
      this.limparCamposControle();
    }
  }

  exibirControles() {
    return <table className="table table-sm table-bordered">
      <thead>
        <tr colSpan='2' className='text-center'>
          <th>Hora início</th>
          <th>Hora fim</th>
        </tr>
      </thead>
      <tbody>
        {!this.props.controleEmissaoBpe || this.props.controleEmissaoBpe.length === 0 ?
          <tr className="alert alert-warning text-center mt-4" role="alert" key={`it_${'index'}`}>
            <td colSpan='3'>
              Nenhum horário foi adicionado.
            </td>
          </tr>
          :
          this.props.controleEmissaoBpe.map((it, index) => <tr key={`it_${index}`}>
            <td className='text-center'>
              {it.horaInicio}
            </td>
            <td className='text-center'>
              {it.horaFim}
            </td>
            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
              <div onClick={() => this.props.removerControle(it)}>Remover</div>
            </td>
          </tr>)}
      </tbody>
    </table>
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="modal fade show" id='modalCadastrarControleEmissaoBPe' role='dialog'
        aria-labelledby='modalCadastrarControleEmissaoBPe' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Controle Emissão BPe</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                onClick={this.limparFormulario}>
                <i className="material-icons">
                  close
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className="col-12">
                    <div className="form-row mt-2">

                      <div className="col-12 col-sm-2 col-md-2">
                        <Field name="horaInicio"
                          css='form-control'
                          component={renderFieldHora}
                          label="Hora início" />
                      </div>

                      <div className="col-12 col-sm-2 col-md-2">
                        <Field name="horaFim"
                          css='form-control'
                          component={renderFieldHora}
                          label="Hora fim" />
                      </div>

                    </div>
                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-2 col-md-2">
                        <button
                          disabled={!this.props.horaInicio || !this.props.horaFim}
                          className="btn btn-sm btn-laranja"
                          onClick={(e) => this.adicionarControle(e)}>
                          Incluir
                        </button>
                      </div>
                    </div>

                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-12 col-md-9">
                        <div className="lista-table">
                          {this.exibirControles()}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="modal-footer">
                  <button type="submit"
                    disabled={this.props.controleEmissaoBpe.length == 0}
                    className="btn btn-laranja">Salvar
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    horaInicio: formValueSelector('formularioCadastroControle')(state, 'horaInicio'),
    horaFim: formValueSelector('formularioCadastroControle')(state, 'horaFim')
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarControleEmissaoBpe
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroControle'
})(ModalCadastrarControleEmissaoBPe));